"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupSessionRow = void 0;
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _utils = require("../../../utils");
var _components = require("../../../components");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _types = require("../../../types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var GroupSessionRow = function GroupSessionRow(_ref) {
  var session = _ref.session,
    rsvp = _ref.rsvp,
    comingSoon = _ref.comingSoon,
    handleCheckedSessions = _ref.handleCheckedSessions,
    isChecked = _ref.isChecked,
    group = _ref.group,
    handlePromptCancel = _ref.handlePromptCancel,
    setShowCancelModal = _ref.setShowCancelModal,
    setCancelSession = _ref.setCancelSession,
    setSessionsModal = _ref.setSessionsModal,
    isLastRow = _ref.isLastRow;
  var isFull = session.rsvpCount === session.capacity;
  var isAttending = (rsvp === null || rsvp === void 0 ? void 0 : rsvp.status) === _types.RsvpStatus.Attending;
  var startsAt = (0, _momentTimezone.default)(session.startAt);
  var endsAt = (0, _momentTimezone.default)(session.endAt);
  var showCheckbox = !comingSoon;
  var _useCssMedia = (0, _utils.useCssMedia)(),
    md = _useCssMedia.md;
  var label = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('pl-[50px] text-grey-75')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mb-[3px] tw-label-medium"
    }, startsAt.format('dddd, MMMM D')), /*#__PURE__*/_react.default.createElement("div", {
      className: "tw-label-regular"
    }, startsAt.format('hh:mma'), " - ", endsAt.format('hh:mma, z')));
  }, [isChecked, startsAt, endsAt]);
  var labelStyles = 'absolute top-[-16px] w-[768px] left-[-38px] pt-[16px] pb-[20px] md:w-[470px]';
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'border-0 border-b border-solid border-grey-20': !isLastRow
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex w-full ', {
      'bg-green1-10': isChecked
    }, 'flex pl-[24px] pt-[16px] pb-[46px] hover:bg-green1-10')
  }, showCheckbox && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isAttending ? /*#__PURE__*/_react.default.createElement(_components.Checkbox, {
    checked: true,
    onChange: function onChange() {
      setCancelSession(session);
      if (md) {
        setSessionsModal(false);
      }
      setShowCancelModal(true);
    },
    labelStyles: labelStyles,
    checkboxStyles: "z-0"
  }, label) : isFull ? /*#__PURE__*/_react.default.createElement("div", {
    className: "full-badge"
  }, "Full") : /*#__PURE__*/_react.default.createElement(_components.Checkbox, {
    value: session.id,
    checked: isChecked,
    onChange: function onChange() {
      return handleCheckedSessions(session.id);
    },
    labelStyles: labelStyles,
    checkboxStyles: "z-0"
  }, label)))));
};
exports.GroupSessionRow = GroupSessionRow;
GroupSessionRow.propTypes = {
  session: _propTypes.default.object,
  rsvp: _propTypes.default.object,
  comingSoon: _propTypes.default.bool,
  handleCheckedSessions: _propTypes.default.func,
  isChecked: _propTypes.default.bool,
  group: _propTypes.default.object,
  handlePromptCancel: _propTypes.default.func,
  setShowCancelModal: _propTypes.default.func,
  setCancelSession: _propTypes.default.func,
  setSessionsModal: _propTypes.default.func,
  isLastRow: _propTypes.default.bool
};
var _default = GroupSessionRow;
exports.default = _default;